module.exports = __webpack_public_path__ + "media/video.7bb7c774.mp4";